import React from 'react';
import { CELL_WIDTH_192, CELL_WIDTH_130 } from 'constants/layout';
import { brandColors } from 'brandColors';
import { useSegment } from 'common/hooks/segment';
import { Terminal } from 'types/Shipping';
import { CircularProgress } from '@mui/material';
import { Title } from './Title';

interface Props {
  terminalsCount: number;
  terminalMap: Terminal[];
  shippingLine: string;
  containerType: string;
  currentTime: string;
  fetching: boolean;
}

const TableHeader: React.FC<Props> = ({
  terminalsCount,
  terminalMap,
  shippingLine,
  containerType,
  currentTime,
  fetching,
}) => {
  const { track } = useSegment();

  const handleTriggerAnalytics = (terminal: Terminal) => {
    track(
      'Outbound Terminal Clicked',
      {
        terminal: terminal.key,
        url: '/empty-appointments',
      },
      { includeUser: true }
    );
  };

  return (
    <div className="z-10 bg-white">
      <div>
        <div className="flex gap-2 items-center pt-8 pb-4">
          <Title
            shippingLine={shippingLine}
            containerType={containerType}
            currentTime={currentTime}
          />
          {fetching && <CircularProgress size={20} />}
        </div>
        <div className="flex">
          <div
            style={{
              minWidth: `${CELL_WIDTH_192}px`,
              borderRight: `0.5px solid ${brandColors.colors.blue[500]}`,
              borderBottom: `0.5px solid ${brandColors.colors.blue[500]}`,
            }}
            className="bg-white px-4 flex items-center text-center font-medium border border-blue-200 shadow-b"
          >
            <h5 className="text-dark">
              Available Terminals ({terminalMap.length}/{terminalsCount})
            </h5>
          </div>
          <div className="flex">
            {terminalMap.map((terminal) => {
              return (
                <div
                  key={terminal.key}
                  className="bg-white py-2 flex justify-center border-blue-200 shadow-b"
                  style={{
                    width: `${CELL_WIDTH_130}px`,
                    border: `0.5px solid ${brandColors.colors.blue[500]}`,
                  }}
                  onClick={() => handleTriggerAnalytics(terminal)}
                >
                  <a
                    href={terminal.website}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="flex flex-col space-y-2 items-center"
                  >
                    <div style={{ width: '64px' }}>
                      <img src={terminal.logo} alt={terminal.name} />
                    </div>
                    <h5 className="font-medium text-blue-900 underline">{terminal.name}</h5>
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableHeader;
